module.exports = __webpack_public_path__ + "img/comm-server.ef7f223b.svg";